export const SET_AUTH_DETAILS = "SET_AUTH_DETAILS";
export const CLEAR_AUTH_DETAILS = "CLEAR_AUTH_DETAILS";
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_SELECTED_STAGE = "SET_SELECTED_STAGE";
export const SET_SELECTED_BLOCK = "SET_SELECTED_BLOCK";
export const SET_GAME_CASE = "SET_GAME_CASE";
export const SET_GAME_STATUS = "SET_GAME_STATUS";
export const ADD_GAME_ACTIVITY = "ADD_GAME_ACTIVITY";
export const CLEAR_GAME_STATE = "CLEAR_GAME_STATE";
export const SAVE_HISTORY_TAKING = "SAVE_HISTORY_TAKING";
export const SET_GAME_PAGE = "SET_GAME_PAGE";
export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const ADD_CHECKLIST = "ADD_CHECKLIST";
export const DELETE_CHECKLIST = "DELETE_CHECKLIST";
export const UPDATE_CHECKLIST = "UPDATE_CHECKLIST";
export const SET_PRESENTATION_FLAG = "SET_PRESENTATION_FLAG";
